import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Nav } from "../components/Nav";
import { Footer } from "../components/Footer";

export const LegalPage = ({ title, intro, sections, testId }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = `${title} — SOCIAL AI`;
  }, [title]);
  return (
    <div className="site legal-stage min-h-screen">
      <Nav />
      <main className="mx-auto max-w-[760px] px-5 pb-24 pt-36 lg:pt-44" data-testid={testId}>
        <Link to="/" data-testid="legal-back-home" className="inline-flex items-center gap-2 text-[14px] font-semibold text-[#7866E8] hover:underline">
          <ArrowLeft size={16} aria-hidden /> Back to home
        </Link>
        <h1 className="mt-6 text-[44px] font-extrabold leading-none tracking-[-0.04em] text-[#08090D] sm:text-[64px]">{title}</h1>
        <p className="mt-4 text-[14px] text-[#777B8D]">Last updated: October 2026</p>
        <p className="mt-8 text-[18px] leading-relaxed text-[#2f3242]">{intro}</p>
        <div className="glass glass-heavy mt-10 space-y-8 rounded-[32px] p-6 sm:p-10">
          {sections.map((s) => (
            <section key={s.h}>
              <h2 className="text-[20px] font-bold tracking-[-0.02em] text-[#08090D]">{s.h}</h2>
              <p className="mt-2 text-[16px] leading-relaxed text-[#3c4052]">{s.p}</p>
            </section>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
};
